import type { Cell, Direction } from '../game/model/types';

const negativeSide = 1;
const positiveSide = 2;
export const bothOppositeSides = negativeSide | positiveSide;

export function sideAdjacencyMask(
  memberCells: readonly Cell[],
  candidateCells: readonly Cell[],
  direction: Direction,
): number {
  const candidateCellKeys = new Set(candidateCells.map(({ x, y }) => `${x},${y}`));
  const horizontal = direction === 'left' || direction === 'right';
  let mask = 0;
  for (const { x, y } of memberCells) {
    if (horizontal) {
      if (candidateCellKeys.has(`${x},${y + 1}`)) mask |= negativeSide;
      if (candidateCellKeys.has(`${x},${y - 1}`)) mask |= positiveSide;
    } else {
      if (candidateCellKeys.has(`${x + 1},${y}`)) mask |= negativeSide;
      if (candidateCellKeys.has(`${x - 1},${y}`)) mask |= positiveSide;
    }
  }
  return mask;
}
